var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdcCoinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "USD Coin (USDC)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#2e79cc",
    opacity: 1,
    "data-original": "#2e79cc",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.92 113.9c0-13.68-8.16-18.41-24.54-20.31-11.66-1.6-14-4.66-14-10.19s3.93-9 11.72-9a11.54 11.54 0 0 1 12.88 8.23 3 3 0 0 0 2.77 2h6.13a2.7 2.7 0 0 0 2.71-2.63v-.18a19.45 19.45 0 0 0-17.55-16V56.1c0-1.54-1.16-2.7-3.12-3.13h-6.14c-1.53 0-2.7 1.16-3.07 3.13v9a19.93 19.93 0 0 0-19.14 19.1c0 12.89 7.79 18 24.17 19.94 10.92 1.9 14.48 4.3 14.48 10.49s-5.46 10.56-12.88 10.56c-10.19 0-13.68-4.3-14.85-10.13a2.83 2.83 0 0 0-2.76-2.33h-6.38a2.64 2.64 0 0 0-2.7 2.58v.49a21.78 21.78 0 0 0 20.8 18.78V144c0 1.54 1.16 2.7 3.13 3.07h6.13a3.31 3.31 0 0 0 3.13-3.07v-9.38a21.42 21.42 0 0 0 19.51-20.68z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.11 154.64a58.41 58.41 0 0 1 0-109.89 4 4 0 0 0 2.33-3.93v-5.28a3 3 0 0 0-2.33-3.06 2.22 2.22 0 0 0-1.59.43 70.25 70.25 0 0 0 0 133.88 2.39 2.39 0 0 0 3.27-.85 2.44 2.44 0 0 0 .29-.75c.36-.36.36-.73.36-1.53v-5.46a5.09 5.09 0 0 0-2.33-3.56zm41.36-121.8a2.34 2.34 0 0 0-3.21.79 2.21 2.21 0 0 0-.29.75c-.37.43-.37.8-.37 1.59v5.46a5.12 5.12 0 0 0 2.33 3.87 58.41 58.41 0 0 1 0 109.71 3.93 3.93 0 0 0-2.33 3.93v5.46a3 3 0 0 0 2.33 3.13 2.23 2.23 0 0 0 1.54-.43 70.51 70.51 0 0 0 0-134.26z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcCoinIcon);
export default __webpack_public_path__ + "static/media/usdc-coin-icon.9c381414536ae11685d0017d7d2376d3.svg";
export { ForwardRef as ReactComponent };